export default "/kiban/_next/static/images/top_yellow-48985d68a1bc65d4da52025a0999e69c.png";